<template>
   <div class="page-padding">
        <TitleGoBackHeader title="programmes"/>
        <ProgramsDashboard :is-mockup="true"/>
   </div>
</template>
<script setup lang="ts">
import TitleGoBackHeader from '@/components/TitleGoBackHeader.vue';
import ProgramsDashboard from '@/components/ProgramsDashboard.vue';
</script>